import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { CustomProductsService } from '../../custom-landing/custom-products/custom-products.service';
import { NgIf, NgFor } from '@angular/common';
import { I18nModule } from '@spartacus/core';

@Component({
    selector: 'app-custom-platform-banner',
    templateUrl: './custom-platform-banner.component.html',
    styleUrls: ['./custom-platform-banner.component.scss'],
    imports: [NgIf, NgFor, I18nModule]
})
export class CustomPlatformBannerComponent implements OnInit {
  @Input() platformBannerList:any = [];
  @Input() UID:any;
  privacyPolicyStr: any;
  termsOfUseStr: any;
              constructor( 
                private customProfileService: CustomProfileService,
                public activeModal: NgbActiveModal,
                private cd: ChangeDetectorRef,
                private customproductservice:CustomProductsService
                ) { }

  ngOnInit(): void {
    this.getFooterData();
    this.platformBannerList;
    console.log('banner', this.platformBannerList);
  }
  getFooterData() {
    this.customproductservice.privacyPolicyValue.subscribe((resp: any)=>{
  
      this.privacyPolicyStr = resp.privacyPolicy;
      this.termsOfUseStr = resp.termsOfUse;
    this.cd.detectChanges();
  });
}
  acceptAndcontinue(){

  this.customProfileService.updateUserConsents(this.UID).subscribe((res)=>{

   })
   localStorage.setItem('displayPopuop', JSON.stringify(false));
  }
}
